import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../i18n/LanguageContext';
import { usePageTitle } from '../components/layout/PageBits';

function NotFoundPage() {
  const { t } = useLang();
  usePageTitle(t('nfTitle'));
  return (
    <section className="min-h-[60vh] flex items-center justify-center px-4 py-24 bg-sky text-center">
      <div>
        <div className="text-6xl" aria-hidden="true">🪔</div>
        <h1 className="mt-4 text-3xl sm:text-4xl font-extrabold">{t('nfTitle')}</h1>
        <p className="mt-3 text-slate-600">{t('nfText')}</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/" className="bg-ink text-white font-bold px-5 py-3 rounded-full">{t('nfHome')}</Link>
          <Link to="/contact" className="bg-white border border-slate-200 font-bold px-5 py-3 rounded-full">{t('navContact')}</Link>
        </div>
      </div>
    </section>
  );
}

export default NotFoundPage;
